export const fileUploadToImage = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      const image = new Image();
  
      reader.onload = (event) => {
        image.src = event.target.result;
        image.onload = () => resolve(image);
        image.onerror = (error) => reject(error);
      };
  
      reader.onerror = (error) => reject(error);
  
      reader.readAsDataURL(file);
    });
  };
  